import { render, staticRenderFns } from "./PlacementStudent.vue?vue&type=template&id=5fe3755c&"
import script from "./PlacementStudent.vue?vue&type=script&lang=js&"
export * from "./PlacementStudent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports